'use client';
import { ReactComponent } from './check-xs.svg';
export const CheckIconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=check-xs.js.map